import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const Contact = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");

  useEffect(() => {
    if (location.state && location.state.data) {
      setPrevLocation(location.state.data);
    } else {
      setPrevLocation("Home");
    }
  }, [location]);

  const [clientName, setClientName] = useState("");
  const [email, setEmail] = useState("");
  const [messages, setMessages] = useState("");

  const [errClientName, setErrClientName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errMessages, setErrMessages] = useState("");

  const [successMsg, setSuccessMsg] = useState("");

  const handleName = (e) => {
    setClientName(e.target.value);
    setErrClientName("");
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };
  const handleMessages = (e) => {
    setMessages(e.target.value);
    setErrMessages("");
  };

  const emailValidation = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
  };

  const handlePost = (e) => {
    e.preventDefault();
    setErrClientName("");
    setErrEmail("");
    setErrMessages("");

    if (!clientName) setErrClientName("Enter your Name");
    if (!email) setErrEmail("Enter your Email");
    else if (!emailValidation(email)) setErrEmail("Enter a Valid Email");

    if (!messages) setErrMessages("Enter your Message");

    if (clientName && email && emailValidation(email) && messages) {
      setSuccessMsg(
        `Thank you, ${clientName}. Your message has been received. Further details will be sent to your email at ${email}.`
      );
      setClientName("");
      setEmail("");
      setMessages("");
    }
  };

  return (
    <div className="max-w-container mx-auto px-4">
      
      <div
        className="relative w-full h-[400px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${require("../../assets/images/products/productOfTheYear.jpg")})`,
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <h1 className="text-4xl font-bold text-white">Contact Us</h1>
        </div>
      </div>

      
      <Breadcrumbs title="Contact" prevLocation={prevLocation} />

      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 py-10">
        
        <div>
          <h1 className="font-titleFont font-semibold text-3xl mb-6">
            Contact Us
          </h1>
          {successMsg ? (
            <p className="text-green-500 font-medium mb-6">{successMsg}</p>
          ) : (
            <form>
              <div className="flex flex-col gap-6">
                <div>
                  <label className="text-base font-titleFont font-semibold">
                    Name
                  </label>
                  <input
                    onChange={handleName}
                    value={clientName}
                    className="w-full py-2 border-b-2 px-2 text-base font-medium placeholder:text-sm outline-none focus:border-primeColor"
                    type="text"
                    placeholder="Enter your name here"
                  />
                  {errClientName && (
                    <p className="text-red-500 text-sm font-semibold mt-1">
                      {errClientName}
                    </p>
                  )}
                </div>
                <div>
                  <label className="text-base font-titleFont font-semibold">
                    Email
                  </label>
                  <input
                    onChange={handleEmail}
                    value={email}
                    className="w-full py-2 border-b-2 px-2 text-base font-medium placeholder:text-sm outline-none focus:border-primeColor"
                    type="email"
                    placeholder="Enter your email here"
                  />
                  {errEmail && (
                    <p className="text-red-500 text-sm font-semibold mt-1">
                      {errEmail}
                    </p>
                  )}
                </div>
                <div>
                  <label className="text-base font-titleFont font-semibold">
                    Message
                  </label>
                  <textarea
                    onChange={handleMessages}
                    value={messages}
                    cols="30"
                    rows="4"
                    className="w-full py-2 border-b-2 px-2 text-base font-medium placeholder:text-sm outline-none focus:border-primeColor resize-none"
                    placeholder="Enter your message here"
                  ></textarea>
                  {errMessages && (
                    <p className="text-red-500 text-sm font-semibold mt-1">
                      {errMessages}
                    </p>
                  )}
                </div>
                <button
                  onClick={handlePost}
                  className="w-full bg-primeColor text-white py-2 font-titleFont text-base font-semibold hover:bg-black transition duration-200"
                >
                  Submit
                </button>
              </div>
            </form>
          )}
        </div>

        
        <div>
          <h2 className="font-titleFont font-semibold text-2xl mb-4">
            Our Location
          </h2>
          <ul className="space-y-4">
            <li>
              <p className="font-medium">Address:</p>
              <p>Shahra-e-Faisal, Karachi, Pakistan</p>
            </li>
            <li>
              <p className="font-medium">Email:</p>
              <p>harvelelectric@gmail.com</p>
            </li>
            <li>
              <p className="font-medium">Phone:</p>
              <p>+92 300 1234567</p>
            </li>
            <li>
              <p className="font-medium">Zip code:</p>
              <p>75510</p>
            </li>
          </ul>
        </div>
      </div>

      
      <div className="w-full h-64 md:h-96">
        <iframe
          title="Karachi Map - Shahra-e-Faisal"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.6215199479257!2d67.03442311432053!3d24.860734984055067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33ed75a2e52d3%3A0x3d317dd5dd14b02e!2sShahra-e-Faisal%2C%20Karachi%2C%20Pakistan!5e0!3m2!1sen!2s!4v1698779463645!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
